"use strict";

// ReactHelper
module.exports = {
	getRoot: function(element, reactDom) {
		reactDom = reactDom || window.ReactDOM;

		element.__reactRoot = element.__reactRoot || reactDom.createRoot(element);

		return element.__reactRoot;
	},

	unmountElement: function (element, reactDom, shouldRecreateRoot) {
		reactDom = reactDom || window.ReactDOM;

		// Check if the component was rendered with React.render
		if (element._reactRootContainer) {
			// If it was rendered with React.render, unmount it in the old style, since
			// using the createRoot method is not supported on that element.
			// See the ReactDOM createRoot function source for more information.
			reactDom.unmountComponentAtNode(element);
		} else {
			var root = element.__reactRoot || reactDom.createRoot(element);
			root.unmount();
		}

		// Clear or recreate the root now that it has been unmounted
		element.__reactRoot = shouldRecreateRoot ? reactDom.createRoot(element) : undefined;

		return element.__reactRoot;
	}
};
